import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/communications')({
  component: CommunicationsPage,
});

function CommunicationsPage() {
  return (
    <div className="container mx-auto px-6 py-8">
      <h1 className="text-3xl font-bold mb-6">Communications</h1>
      <p className="text-muted-foreground">
        Communication templates and history. This page is under development.
      </p>
    </div>
  );
}
